export default function InnerSearchLine() {
    return (<svg xmlns="http://www.w3.org/2000/svg" width="1" height="16" viewBox="0 0 1 16">
        <line id="Line_1102" data-name="Line 1102" y2="15" transform="translate(0.5 0.5)" fill="none" stroke="#8e8e8e" strokeLinecap="round" strokeWidth="1" />
    </svg>
    )
}